import React, { createRef, useEffect } from 'react';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getItem } from 'src/util/localStorage';
import { divideQueryParams } from 'src/util/queryParams';
import SideMenu from '../SideMenu';
import CFooter from '../Footer';
import CHeader from '../Header';
import Cart from '../Cart/Cart';
import Loader from '../Loader/Loader';

const { Header, Content, Footer } = Layout;

function addIdInUrl(location, history, projects) {
  const currentProject =
    getItem('currentProject') && getItem('currentProject') !== undefined
      ? JSON.parse(getItem('currentProject'))
      : '';

  const { pathname, search } = location;
  const paramsObj = divideQueryParams(search);
  const idFromUrl = paramsObj.get('id');
  const filter = paramsObj.get('filter');
  const isIdFromUrlInOurProjects = projects.some((project) => project._id === idFromUrl);

  if (projects.length !== 0) {
    if (idFromUrl && currentProject && idFromUrl !== currentProject?._id) {
      if (filter) {
        history.replace(`${pathname}?id=${idFromUrl}&filter=${filter}`);
      } else {
        history.replace(`${pathname}?id=${idFromUrl}`);
      }
    } else if (!idFromUrl && currentProject) {
      if (filter) {
        history.replace(`${pathname}?id=${currentProject._id}&filter=${filter}`);
      } else {
        history.replace(`${pathname}?id=${currentProject._id}`);
      }
    } else if (!idFromUrl && !currentProject && !pathname.includes('/projects')) {
      history.push(`/projects`);
    } else if (!isIdFromUrlInOurProjects && !pathname.includes('/projects')) {
      history.push(`/projects`);
    }
  }
}

const InnerContent = ({ children, location }) => {
  const { projectId } = useParams();
  const history = useHistory();
  const myElem = createRef();

  const isCartOpen = useSelector(({ cart }) => cart.isCartOpen);
  const projects = useSelector(({ project }) => project?.projects);
  const currentProject = useSelector(({ project }) => project.currentProject);

  useEffect(() => {
    addIdInUrl(location, history, projects);
  }, [currentProject, location, projects]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        className="header"
        style={{
          background: 'white',
          borderBottom: '1px solid #F0F4FF',
          padding: '0px',
          zIndex: 2
        }}
      >
        <CHeader />
      </Header>
      <Layout
        style={{
          background: 'white',
          paddingBottom: '80px'
        }}
      >
        {currentProject && <SideMenu />}
        {currentProject || location?.pathname === '/projects' || projectId ? (
          <Content>
            <Content style={{}}>{children}</Content>
          </Content>
        ) : (
          <Loader size={50} />
        )}
        <div
          ref={myElem}
          style={{
            display: isCartOpen ? 'block' : 'none',

            height: 'calc(100% - 128px)',

            // position: 'fixed',
            // right: '0px',
            // top: '64px',
            position: 'absolute',
            right: '0px',
            top: '64px',
            width: 360,
            zIndex: 1
          }}
        />
        <Cart getRef={() => myElem.current} visible={isCartOpen} />
      </Layout>
      <Footer
        style={{
          background: '#FCFCFC',
          bottom: 0,
          height: '64px',
          padding: 0,
          position: 'fixed',
          textAlign: 'center',
          width: '100%',
          zIndex: 2
        }}
      >
        <CFooter />
      </Footer>
    </Layout>
  );
};

export default InnerContent;
